import React, { useEffect, useRef } from 'react';

export type RailProps = {
  title: string;
  viewAllHref?: string;
  viewAllLabel?: string;
  scrollerLabel: string;
  children: React.ReactNode;
};

const Rail: React.FC<RailProps> = ({
  title,
  viewAllHref,
  viewAllLabel = 'View all',
  scrollerLabel,
  children,
}) => {
  const scrollerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const onWheel = (event: WheelEvent) => {
      if (event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      const page = document.scrollingElement || document.documentElement;
      if (!page) return;
      page.scrollTop += event.deltaY;
      event.preventDefault();
    };
    scroller.addEventListener('wheel', onWheel, { passive: false });
    return () => scroller.removeEventListener('wheel', onWheel);
  }, []);

  return (
  <section data-testid="stream-rail">
    <div className="mb-3 flex items-baseline justify-between gap-3">
      <h2 className="font-stream-display text-xl font-bold uppercase tracking-wide text-stream-ink">
        {title}
      </h2>
      {viewAllHref ? (
        <a href={viewAllHref} className="font-stream-body text-sm text-stream-muted">
          {viewAllLabel}
        </a>
      ) : null}
    </div>
    <div
      ref={scrollerRef}
      tabIndex={0}
      aria-label={scrollerLabel}
      data-testid="stream-rail-scroller"
      className="flex w-[round(down,100%,18.75rem)] min-w-72 max-w-full snap-x snap-mandatory gap-3 overflow-x-auto overflow-y-hidden pb-1 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden [&>*]:snap-start"
    >
      {children}
    </div>
  </section>
  );
};

export default Rail;
